<script setup lang="ts">
import type { BingoLatestWinnersResponse } from '@game/types'
import { useThemeIllustration, mediaUrl } from '#imports'

export interface BingoWinnersProps {
    bingoWinners?: Omit<BingoLatestWinnersResponse, 'success'>
}

const props = defineProps<BingoWinnersProps>()

const bigWinIllustration = useThemeIllustration('bigWin')
</script>

<template>
    <div class="bingo-winners__container">
        <ClientOnly v-if="props.bingoWinners?.winners?.length">
            <Transition
                name="fade-in-delayed"
                appear
            >
                <NuxtImg
                    preset="local"
                    provider="cloudflare"
                    loading="lazy"
                    :src="bigWinIllustration?.src ?? mediaUrl('/media/bingo/bingo-konfetti.png')"
                    sizes="334px md:468px"
                    class="bingo__konfetti"
                    width="334"
                    height="165"
                    quality="70"
                />
            </Transition>
            <div class="bingo-winners">
                <GameWinnerList
                    class="bingo-winners__low"
                    :winners="props.bingoWinners?.winners || []"
                    tile-variant="bingo"
                    :fade="false"
                />
                <Transition
                    name="flip-in-bingo"
                    appear
                >
                    <GameWinnerTile
                        v-if="props.bingoWinners?.megaPrizeWinners?.[0]"
                        :key="props.bingoWinners.megaPrizeWinners[0].id"
                        :is-mega-prize="true"
                        variant="bingo"
                        :winner="props.bingoWinners.megaPrizeWinners[0]"
                    />
                </Transition>
            </div>
        </ClientOnly>
    </div>
</template>

<style lang="scss">
.bingo-winners {
    padding-top: 10px;

    @media (min-width: $screen-md) {
        display: flex;
    }

    &__head {
        position: relative;
        margin: 30px 0 0;
        z-index: 1;

        @media (min-width: $screen-md) {
            margin-top: 70px;
        }

        @media (min-width: $screen-lg) and (min-height: 710px) {
            margin-top: 80px;
        }

        @media (min-width: $screen-lg) {
            max-width: 510px;
        }
    }

    &__container {
        position: relative;
        min-height: 340px; // prevent Layout shift

        @media (min-width: $screen-md) {
            display: flex;
            min-height: 60px;
        }
    }

    &__low {
        max-width: 140px;

        @media (min-width: $screen-sm) {
            max-width: 160px;
        }

        @media (min-width: $screen-md) {
            max-width: none;
        }
    }
}
</style>
